<template>
    <div class="homepage-search-vehicle__container">
        <h3 class="homepage-search-vehicle__title">Search for your next used vehicle...</h3>

        <UsedSearchResultsFilter
            placeholder="Any Make"
            display-name="makes"
            options-key="manufacturer"
            type="select"
            :multiple="usedCarSearch"
            :enableSearch="true"
            @field:open="onInteract"
        />
        <UsedSearchResultsFilter
            placeholder="Any Model"
            display-name="models"
            options-key="model"
            :enableSearch="true"
            type="select"
            :multiple="usedCarSearch"
            @field:open="onInteract"
        />
        <UsedSearchResultsFilter
            placeholder="Any Budget"
            options-key="maxPrice"
            :enableSearch="false"
            type="select"
            :multiple="false"
            :formatFunction="formatPrice"
            @field:open="onInteract"
        />

        <button
            type="button"
            @click="search"
            :disabled="buttonDisabled"
            class="btn btn--primary homepage-search-vehicle__filters-btn"
        >
            <img
                width="24"
                height="24"
                src="/images/white-search-icon.svg"
            />
            <span>Search {{ countFormatted }} used cars</span>
        </button>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import UsedSearchResultsFilter from './components/UsedSearchResultsFilter.vue';
import numberFormat from '../used-vue/api/NumberFormat';
import { CurrencyDirective } from "vue-currency-input";
import Location from './components/Location.vue';

export default {
    components: {
        UsedSearchResultsFilter,
        Location
    },
    directives: {
        currency: CurrencyDirective,
    },
    data() {
        return {

        };
    },
    computed: {
        ...mapGetters({
            searchType: "SearchOptions/searchType",
            userOptions: "SearchOptions/userOptions",
        }),
        ...mapState("Layout", [
            'saleEventLive',
        ]),
        countFormatted: {
            get() {
                return numberFormat(this.$store.state.SearchOptions.animatedCount);
            },
        },
        usedCarSearch() {
            return false; // disable multi select
            return this.searchType === 'Used Cars'
        },
        buttonDisabled() {
            if (!this.userOptions) return true;

            return false;
        },
        viewAllUrl() {
            return '/used-vehicles/results';
        }
    },
    methods: {
        ...mapActions("Layout", ["isSalesEventLive"]),

        onInteract() {
            scrollToElementId('homepage-search-container');
        },
        search() {
            if(this.saleEventLive){
                this.$store.dispatch("SearchOptions/updateOptions", {
                    ['sortBy']: 'saleEvent'
                });
            }
            this.$store.dispatch("SearchOptions/goToSearch");
        },

        number_format(num) {
            return numberFormat(num);
        },

        formatPrice(price) {
            return 'Up to £' + numberFormat(price, 0);
        }
    },

    beforeCreate() {
        if (!this.$store.hasModule('Layout')) {
            this.$store.registerModule('Layout', require('../used-vue/store/modules/layout').default);
        }
    },
    created() {
        this.$store.dispatch('SearchOptions/getOptions');
    },
    async mounted() {
        await this.isSalesEventLive();
    },
}
</script>
